var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScoreIcon = function SvgScoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M18.92 7.856a1.75 1.75 0 0 0-1.39-1.14l-4.09-.626-1.892-3.725c-.591-1.176-2.233-1.27-2.955-.17a2 2 0 0 0-.098.17L6.604 6.09l-4.136.593a1.71 1.71 0 0 0-1.379 1.139c-.21.62-.041 1.304.433 1.755l3.03 2.916-.706 4.09c-.114.64.153 1.289.684 1.664a1.7 1.7 0 0 0 1.789.136l3.703-1.936 3.702 1.936c1.167.608 2.554-.276 2.497-1.59a2 2 0 0 0-.024-.221l-.707-4.079L18.475 9.6c.47-.448.642-1.125.445-1.743z"
  })));
};
export { SvgScoreIcon as ReactComponent };